import { render, staticRenderFns } from "./agreementOrdersTG.vue?vue&type=template&id=685cd756&scoped=true&lang=pug"
import script from "./agreementOrdersTG.vue?vue&type=script&lang=js"
export * from "./agreementOrdersTG.vue?vue&type=script&lang=js"
import style0 from "./agreementOrdersTG.vue?vue&type=style&index=0&id=685cd756&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685cd756",
  null
  
)

export default component.exports